"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreSaveReleaseModule = void 0;
const base_1 = require("./base");
class PreSaveReleaseModule extends base_1.SurveyModule {
    constructor(props) {
        super(props);
        this._type = "PreSaveRelease";
        this.actionRequired = !props.data;
    }
    validate() {
        return this.data ? true : false;
    }
    toBuilderConfig() {
        return {
            id: this.id,
            type: this.type,
            actionRequired: this.actionRequired,
            style: this.style,
            data: this.data,
        };
    }
    toSurveyConfig() {
        return {
            id: this.id,
            type: this.type,
            actionRequired: this.actionRequired,
            style: this.style,
            data: this.data,
        };
    }
    editProps() {
        return undefined;
    }
}
exports.PreSaveReleaseModule = PreSaveReleaseModule;
//# sourceMappingURL=PreSaveRelease.js.map